import { Heading, Spacer } from '@sparemin/blockhead';
import React, { useCallback } from 'react';
import Button from 'components/Button';
import { useSocialShareModal } from '../SocialShareModalContext';
import { useSocialSharePlatform } from '../SocialSharePlatforms';
import { socialShareModalAccountSelectBlock as block } from '../utils';

export type SwitchAccountsProps = {
  onCancel?: () => void;
  onClose?: () => void;
};

const SwitchAccounts: React.FC<SwitchAccountsProps> = ({
  onCancel,
  onClose,
}) => {
  const { selectedAccount } = useSocialShareModal();
  const { authenticate, authenticating } = useSocialSharePlatform();

  const handleLogOut = useCallback(() => {
    onClose();
    authenticate();
  }, [authenticate, onClose]);

  return (
    <Spacer
      orientation="vertical"
      space="20px"
      className={block('switch-account-container')}
    >
      <Heading level={2}>
        Log out of {selectedAccount?.handle} and into another account?
      </Heading>

      <Spacer
        orientation="horizontal"
        space="10px"
        align="center"
        justify="between"
        className={block('switch-account-buttons')}
      >
        <Button
          fluid
          theme="cancel"
          disabled={authenticating}
          onClick={onCancel}
        >
          Cancel
        </Button>

        <Button
          theme="submit"
          fluid
          disabled={authenticating}
          onClick={handleLogOut}
        >
          Log out
        </Button>
      </Spacer>
    </Spacer>
  );
};

export default SwitchAccounts;
